export default __webpack_public_path__ + "static/media/emoji-lampe.a317caef.svg";